<ng-container *ngIf="!embedded">
  <app-nav-bar></app-nav-bar>
  <app-side-bar></app-side-bar>
  <app-settings-modal></app-settings-modal>
</ng-container>

<div class="container shop-company-form-page" [ngClass]="{ 'embedded-view': embedded }">
  <div class="page-header">
    <div>
      <h1>
        {{
          (isEditMode ? 'EDIT_SHOP_COMPANY' : 'NEW_SHOP_COMPANY')
            | translate
        }}
      </h1>
      <p>{{ 'SHOP_COMPANY_FORM_HELP' | translate }}</p>
    </div>
    <button type="button" class="secondary-btn" (click)="backToList()">
      {{ 'BACK' | translate }}
    </button>
  </div>

  <div class="tabs">
    <button
      type="button"
      [class.active]="activeTab === 'general'"
      (click)="selectTab('general')"
    >
      {{ 'GENERAL_DATA' | translate }}
    </button>
    <button
      type="button"
      [class.active]="activeTab === 'theme'"
      [disabled]="!shopCompanyId"
      (click)="selectTab('theme')"
    >
      {{ 'THEME' | translate }}
    </button>
  </div>

  <div class="alert alert-danger" *ngIf="errorMessage">
    {{ errorMessage | translate }}
  </div>
  <div class="alert alert-success" *ngIf="successMessage">
    {{ successMessage | translate }}
  </div>

  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>

  <div class="form-card" *ngIf="!loading && activeTab === 'general'">
    <form [formGroup]="companyForm" (ngSubmit)="saveGeneralData()">
      <div class="row">
        <div class="col-md-6 form-field">
          <label for="companyName">{{ 'NAME' | translate }}</label>
          <input
            id="companyName"
            class="form-control"
            [class.is-invalid]="isControlInvalid('companyName')"
            formControlName="companyName"
          />
          <small class="text-danger" *ngIf="hasControlError('companyName', 'required')">
            {{ 'REQUIRED_FIELD' | translate }}
          </small>
        </div>
        <div class="col-md-6 form-field">
          <label for="companyLegalName">{{ 'LEGAL_NAME' | translate }}</label>
          <input
            id="companyLegalName"
            class="form-control"
            [class.is-invalid]="isControlInvalid('companyLegalName')"
            formControlName="companyLegalName"
          />
          <small
            class="text-danger"
            *ngIf="hasControlError('companyLegalName', 'required')"
          >
            {{ 'REQUIRED_FIELD' | translate }}
          </small>
        </div>
        <div class="col-md-6 form-field">
          <label for="companyPhone">{{ 'PHONE' | translate }}</label>
          <input
            id="companyPhone"
            class="form-control"
            [class.is-invalid]="isControlInvalid('companyPhone')"
            formControlName="companyPhone"
          />
          <small class="text-danger" *ngIf="hasControlError('companyPhone', 'required')">
            {{ 'REQUIRED_FIELD' | translate }}
          </small>
        </div>
        <div class="col-md-6 form-field">
          <label for="companyWebsiteUrl">{{ 'WEBSITE' | translate }}</label>
          <input
            id="companyWebsiteUrl"
            class="form-control"
            [class.is-invalid]="isControlInvalid('companyWebsiteUrl')"
            formControlName="companyWebsiteUrl"
            placeholder="https://"
          />
          <small class="text-danger" *ngIf="isControlInvalid('companyWebsiteUrl')">
            {{ 'VALID_URL_MESSAGE' | translate }}
          </small>
        </div>
        <div class="col-md-6 form-field">
          <label for="status">{{ 'STATUS' | translate }}</label>
          <select id="status" class="form-select" formControlName="status">
            <option [ngValue]="1">{{ 'ACTIVE' | translate }}</option>
            <option [ngValue]="0">{{ 'INACTIVE' | translate }}</option>
          </select>
        </div>
      </div>

      <div class="form-actions">
        <button class="primary-btn" type="submit" [disabled]="saving">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            *ngIf="saving"
          ></span>
          {{ (saving ? 'SAVING' : isEditMode ? 'SAVE' : 'CREATE') | translate }}
        </button>
      </div>
    </form>
  </div>

  <app-shop-company-theme-settings
    *ngIf="activeTab === 'theme' && shopCompanyId && shopCompany"
    [shopId]="themingService.shopId"
    [shopCompanyId]="shopCompanyId"
    [shopCompany]="shopCompany"
    [parentSaving]="saving"
    (saveThemeChanges)="saveTheme($event)"
  ></app-shop-company-theme-settings>
</div>

<ng-container *ngIf="!embedded">
  <app-footer></app-footer>
</ng-container>
